import React, { Component } from "react";
import { VzPageContainer } from "../../layouts/VzPageContainer";
export default class ManagePrincipals extends Component {
  render() {
    return (
      <div>
        <VzPageContainer title="Manage Principals">
        </VzPageContainer>
      </div>
    );
  }
}
